import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.news-module-carousel');
  carousels.forEach(carousel => {
    new Swiper(carousel, {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: true,
      // pagination: {
      //   el: carousel.querySelector('.swiper-pagination'),
      //   clickable: true,
      // },
      // navigation: {
      //   nextEl: carousel.querySelector('.swiper-button-next'),
      //   prevEl: carousel.querySelector('.swiper-button-prev'),
      // },
    });
  });
});